import * as React from "react";
import "../filters.scss";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import SaveFiltersButtonConfigView, {SaveFiltersConfig} from "./SaveFiltersButtonConfigView";
import ButtonSecondary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";

interface IProps {
	/**
	 * On save
	 */
	onSave: (config: SaveFiltersConfig) => any
	/**
	 * Save button disabled flag
	 */
	saveViewButtonDisabled?: boolean
}

interface IState {
	/**
	 * Show config box
	 */
	showConfig: boolean
}

export default class SaveFiltersButton extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = { showConfig: false }
	}

	render() {
		return (
			<div className={"c-save-filters reset-dropdown-right"}>
				<ButtonSecondary label={"Save view"}
								 onClick={() => this.setState({showConfig: true})}
								 disabled={this.props.saveViewButtonDisabled}/>
				{this.state.showConfig && <DropDownWrapper width={300} onOutsideClick={() => this.setState({showConfig: false})}>
					<SaveFiltersButtonConfigView
						onCancel={() => this.setState({showConfig: false})}
						onDone={(config) => {
							this.setState({showConfig: false}, () => {
								this.props.onSave(config);
							})
						}}/>
				</DropDownWrapper>}
			</div>
		);
	}

}
